import { type FeatureState, useFeature } from '../feature'

export const useQuizFeature = (): FeatureState => {
  return useFeature({
    featureId: 'Feature:Quiz',
    placeholder: false,
  })
}
